import { render, staticRenderFns } from "./MainHotels.vue?vue&type=template&id=45bf215d&"
import script from "./MainHotels.vue?vue&type=script&lang=js&"
export * from "./MainHotels.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports